module.exports = __webpack_public_path__ + "img/19_81.3311668a.png";